'use client';

import dynamic from 'next/dynamic';

const LazyTimeRemaining = dynamic(() => import('./TimeRemaining'));

export default LazyTimeRemaining;
